import { HiPlus } from "react-icons/hi2";

export const PlusIcon = ({ width, height, color, ...props }) => (
  <HiPlus
    size={width || height || 20}
    color={color || "currentColor"}
    {...props}
  />
);
